// Shared helpers for Client Billing Profile

export const FREQUENCIES = [
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "yearly", label: "Yearly" },
  { value: "one_off", label: "One-off" },
];

export const serviceRenewsInMonth = (service, year, month) => {
  // month is 1-12; returns { renews, day, needsDate }
  let anchor = null;
  if (service.renewal_date) {
    const [y, m, d] = String(service.renewal_date).slice(0, 10).split("-").map(Number);
    if (y && m && d) anchor = { y, m, d };
  }
  const freq = service.frequency;
  if (freq === "monthly") return { renews: true, day: anchor?.d || null, needsDate: false };
  if (!anchor) return { renews: false, day: null, needsDate: true };
  if (freq === "yearly") return { renews: anchor.m === month, day: anchor.d, needsDate: false };
  if (freq === "quarterly") return { renews: (((month - anchor.m) % 3) + 3) % 3 === 0, day: anchor.d, needsDate: false };
  if (freq === "one_off") return { renews: anchor.y === year && anchor.m === month, day: anchor.d, needsDate: false };
  return { renews: false, day: null, needsDate: false };
};

export const frequencyLabel = (value) =>
  FREQUENCIES.find((f) => f.value === value)?.label || value;

// Costs are always recurring — no one-off option
export const COST_FREQUENCIES = FREQUENCIES.filter((f) => f.value !== "one_off");

export const isOffice365 = (name) =>
  /office\s*365|microsoft\s*365|\bo365\b|\bm365\b/i.test(name || "");

export const formatAUD = (amount) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(
    amount || 0
  );

// Normalise an amount to its monthly equivalent (one-off excluded)
export const monthlyEquivalentAmount = (amount, frequency) => {
  const value = parseFloat(amount) || 0;
  switch (frequency) {
    case "monthly":
      return value;
    case "quarterly":
      return value / 3;
    case "yearly":
      return value / 12;
    default:
      return 0;
  }
};

// Normalise a service price to its monthly equivalent (one-off excluded)
export const monthlyEquivalent = (service) =>
  monthlyEquivalentAmount(service.price, service.frequency);

export const CHART_COLORS = [
  "#2563eb",
  "#0891b2",
  "#7c3aed",
  "#059669",
  "#d97706",
  "#dc2626",
  "#db2777",
  "#475569",
  "#0d9488",
  "#9333ea",
];
